import React from 'react';
import { FaStar } from 'react-icons/fa';
import { RiWallet3Line, RiUserFollowLine, RiArrowUpSLine } from "react-icons/ri";
import { MdOutlineLocationOn } from "react-icons/md";
import { BsCashStack, BsPeople } from "react-icons/bs";
import { useTranslation } from 'react-i18next';
import personImg from '../../assets/person/images.jpg';
import styles from './ProfileCard.module.css'; // Import the CSS module


function ProfileCard() {
    const { i18n } = useTranslation();
    const isRtl = i18n.language === 'ar';
    return (
        <div className={`${styles.first}`}>
            <div className={`${styles.second}`}>
                <div className={`${styles.third}`}>
                    <svg height="100" width="100" className={`${styles.svg1}`}>
                        <circle cx="50" cy="50" r="45" stroke={"#4CAF50"} strokeWidth="3" fill="transparent" />
                    </svg>
                    <img src={personImg} alt={`profile`}  className={`${styles.four}`}/>
                    <div className={`${styles.five}`}>
                        <FaStar color={"#4CAF50"} style={{ fontSize: "10px" }} />
                    </div>
                </div>
                <div className={`${styles.six}`}>
                    <div style={{ fontSize: "18px", fontWeight: "bold" }}>David James</div>
                    <div style={{ display: "flex" }}>
                        <div>
                            <MdOutlineLocationOn className={`${styles.seven}`}/>
                        </div>

                        <div>United Arab Emirates
                        </div>
                    </div>
                    <div style={{ display: "flex" }}>
                        <div style={{ fontSize: "12px", color: "green" }}>+4.58%</div>
                        <div style={{ marginTop: "5px" }}>(Last 1 week)</div>
                    </div>
                    <div className={`${styles.eight}`}>
                        <div className={`${styles.nine}`}>RISK</div>
                        <div className={`${styles.ten}`}>1</div>
                    </div>
                </div>
                <div className={`${styles.fourteen}`} style={{ marginRight: isRtl ? "" : "-60px", marginLeft: isRtl ? "-54px" : "0" }}>
                    <div style={{ fontSize: "12px", fontWeight: "bold" }}>
                        <RiUserFollowLine style={{ height: "20px", marginRight: "5px", color: "#007bff", fontSize: "13px" }} />
                        14,540</div>
                    <div style={{ fontSize: "12px" }}>Followers</div>
                </div>
                <div className={`${styles.eleven}`}>
                    <div className={`${styles.twelve}`}></div>
                    <div style={{ margin: 0 }}>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <div style={{ display: "flex" }}>
                                <div style={{ color: "green", marginLeft: "5px" }}> ^ 147 COPIERS</div>
                                <div>LAST 7 DAYS</div>
                            </div>
                            <button className={`${styles.button}`}>
                                COPY
                            </button>
                        </div>

                    </div>
                </div>
                <div className={`${styles.fourteen}`} style={{  marginLeft: isRtl ? "0" : "-54px", marginRight: isRtl ? "-60px" : "0" }}>
                    <div style={{ fontSize: "12px", fontWeight: "bold" }}>
                        <BsPeople className={`${styles.thirteen}`} />
                        43,321</div>
                    <div style={{ fontSize: "12px" }}>COPIERS</div>
                </div>
            </div>
        </div>
    )
}

export default ProfileCard;
